import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { ControlByRequest } from "src/app/core/services/business/model/control-by-request";
import { Control } from "src/app/core/services/business/model/control";
import { ControlService } from "src/app/core/services/business/service/control.service";
import { ControlByRequestService } from "src/app/core/services/business/service/control-by-request.service";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";

@Component({
  selector: "app-add-control-by-request",
  templateUrl: "./add-control-by-request.component.html",
  styleUrls: ["./add-control-by-request.component.scss"],
})
export class AddControlByRequestComponent implements OnInit {
  @Input() controlId;
  @Input() requestId;

  controlByRequest: ControlByRequest = new ControlByRequest();
  control: Control;
  request: Request;

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _controlService: ControlService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _controlByRequestService: ControlByRequestService,
    private _requestService: RequestService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      avis: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getControlById(this.controlId);
    this.getRequestById(this.requestId);
  }

  getControlById(id) {
    this._controlService.getControlById(id).subscribe(
      (data) => {
        this.control = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getRequestById(id) {
    this._requestService.getRequestById(id).subscribe(
      (data) => {
        this.request = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.spinner.show();

    this.controlByRequest.control = this.control;
    this.controlByRequest.request = this.request;

    this.pressButton = true;
    this._controlByRequestService
      .postControlByRequest(this.controlByRequest)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
